var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUndo = function SvgUndo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83301 15.8335V14.1668H11.7497C12.6247 14.1668 13.3851 13.8891 14.0309 13.3335C14.6768 12.7779 14.9997 12.0835 14.9997 11.2502C14.9997 10.4168 14.6768 9.72238 14.0309 9.16683C13.3851 8.61127 12.6247 8.3335 11.7497 8.3335H6.49967L8.66634 10.5002L7.49967 11.6668L3.33301 7.50016L7.49967 3.3335L8.66634 4.50016L6.49967 6.66683H11.7497C13.0969 6.66683 14.2531 7.10433 15.2184 7.97933C16.1837 8.85433 16.6663 9.94461 16.6663 11.2502C16.6663 12.5557 16.1837 13.646 15.2184 14.521C14.2531 15.396 13.0969 15.8335 11.7497 15.8335H5.83301Z",
    fill: "white"
  }))));
};
export { SvgUndo as ReactComponent };
export default __webpack_public_path__ + "assets/73e9e95e.svg";